<!--
    描述：全局tab组件
    时间：2020-09-09
    Created by sjq
-->
<template>
	<el-tabs v-model="activeName"
			 @tab-click="handleClick">
		<el-tab-pane v-for="(i, index) in dataArray"
					 :key="keyName + index"
					 :label="i.label" 
					 :name="i.name"></el-tab-pane>
	</el-tabs>
</template>

<script>
export default {
	name: 'tab',
	props: {
		dataArray: { // 主数组, 选项卡的数量
			type: Array,
			default: () => {
				return [
					{ label: '标签一', name: '1' },
					{ label: '标签二', name: '2' },
					{ label: '标签三', name: '3' }
				]
			}
		},
		
		keyName: { // key值, 默认10位, 随机数字字母
			type: String,
			default: () => {
				var ans = ''
				var arr = '12345abcde'
                for(var i = 20; i > 0; i--) {
                    ans += arr[Math.floor(Math.random() * arr.length)]
				}
                return ans
			}
		},

		value: { // 双向绑定
			type: String,
			default: ''
		}
	},
	data() {
		return {
			activeName: ''
		}
	},
	methods: {
		handleClick(val) {
			this.$emit('change', this.activeName, val)
		}
	},
	created() {
		this.activeName = this.value
	},
	watch: {
		activeName (val) {
			this.$emit('input', val)
		}
	}
}
</script>

<style lang="less" scoped>
// 该组件原生样式已被覆盖, left-tab类下使用组件, 下方原生滚动条被隐藏(assets/style/reset.less)
</style>
